// @mui material components
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const ConfiguratorRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "openConfigurator",
})<{ openConfigurator?: boolean }>(({ theme, openConfigurator }) => ({
  ...theme.custom.widgets.configurator.panelRoot(openConfigurator),
}));

export default ConfiguratorRoot;
